<template>
  <div class="order-summary-block" v-if="cart.product !== null">
    <div class="summary-block-heading" @click="toggleSummary">
      <div class="step-title-v2 d-flex flex-row justify-content-between align-items-center mb-0">
        <h2 class="title mb-0">{{ fields.tr_order_summary_text }}</h2>
        <transition name="fade-in-out"
          ><span class="ml-auto heading-price" v-if="!isSummaryOpen">{{
            formattedString
              ? formattedString.replace(/0.00|0,00/g, countTotalPrice())
              : $filters.money(countTotalPrice(), currencyLocale, currencyCode)
          }}</span></transition
        >
        <span class="chevron-icon">
          <svg
            :class="{ 'rotate-180': isSummaryOpen }"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            shape-rendering="geometricPrecision"
            text-rendering="geometricPrecision"
            image-rendering="optimizeQuality"
            fill-rule="evenodd"
            clip-rule="evenodd"
            viewBox="0 0 512 298.04"
          >
            <path
              fill-rule="nonzero"
              d="M12.08 70.78c-16.17-16.24-16.09-42.54.15-58.7 16.25-16.17 42.54-16.09 58.71.15L256 197.76 441.06 12.23c16.17-16.24 42.46-16.32 58.71-.15 16.24 16.16 16.32 42.46.15 58.7L285.27 285.96c-16.24 16.17-42.54 16.09-58.7-.15L12.08 70.78z"
            />
          </svg>
        </span>
      </div>
    </div>
    <Vue3SlideUpDown v-model="isSummaryOpen" :duration="300">
      <div class="summary-wrapper">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <span class=""
            >{{ cart.product.display_name }} x {{ cart.product.amount }}
            <span style="color: #ff6d00" v-if="cart.product.discount"
              >+
              {{ $filters.money(cart.product.discount, currencyLocale, currencyCode) }} OFF!</span
            >
          </span>
          <span>
            {{
              formattedString
                ? formattedString.replace(
                    /0.00|0,00/g,
                    Number(cart.product.price * cart.product.amount).toFixed(2)
                  )
                : $filters.money(
                    cart.product.price * cart.product.amount,
                    currencyLocale,
                    currencyCode
                  )
            }}</span
          >
        </div>
        <div
          v-if="cart.product.shipping_price > 0"
          class="d-flex flex-row align-items-center justify-content-between"
        >
          <span class="">{{ fields.tr_shipping_text }}:</span>
          <span>{{
            formattedString
              ? formattedString.replace(
                  /0.00|0,00/g,
                  Number(cart.product.shipping_price).toFixed(2)
                )
              : $filters.money(cart.product.shipping_price, currencyLocale, currencyCode)
          }}</span>
        </div>
        <div v-else class="d-flex flex-row align-items-center justify-content-between">
          <span class="shipping">{{ fields.tr_shipping_text }}:</span>
          <span style="color: green">
            <strong>{{ fields.tr_free_text }}</strong></span
          >
        </div>
        <div
          v-if="checkWarrantyState()"
          class="d-flex flex-row align-items-center justify-content-between warranty-label"
        >
          <span class="">{{ fields.tr_warranty_text }}:</span>
          <span>{{
            formattedString
              ? formattedString.replace(/0.00|0,00/g, countWarrantyPrice())
              : $filters.money(countWarrantyPrice(), currencyLocale, currencyCode)
          }}</span>
        </div>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <span class="font-weight-bold">{{ fields.tr_todays_total_text }}: </span>
          <span class="font-weight-bold">{{
            formattedString
              ? formattedString.replace(/0.00|0,00/g, countTotalPrice())
              : $filters.money(countTotalPrice(), currencyLocale, currencyCode)
          }}</span>
        </div>
      </div>
    </Vue3SlideUpDown>
  </div>
</template>

<script setup>
import { useCartStore } from '../state/cart'
import { ref } from 'vue'
import { Vue3SlideUpDown } from 'vue3-slide-up-down'

const fields = window.msg
const currencyCode = window.productData?.currency_code
const currencyLocale = window.locale
const cart = useCartStore()
const isSummaryOpen = ref(false)
const formattedString = window.formattedString

function checkWarrantyState() {
  let warrantySelected = cart.warrantyState
  if (!cart.isWarrantySelected) {
    warrantySelected = false
  }
  return warrantySelected
}

function countTotalPrice() {
  let totalPrice = 0
  if (!checkWarrantyState()) {
    totalPrice = cart.product.price * cart.product.amount + parseFloat(cart.product.shipping_price)
  } else {
    totalPrice =
      cart.product.price * cart.product.amount +
      parseFloat(cart.product.shipping_price) +
      parseFloat(countWarrantyPrice())
  }
  return Number(totalPrice).toFixed(2)
}
function countWarrantyPrice() {
  const multiply_by_product = cart.warrantyPriceCalculation

  if (multiply_by_product) {
    return Number(cart.product.amount * parseFloat(cart.product.warranty_price)).toFixed(2)
  } else {
    return parseFloat(Number(cart.product.warranty_price).toFixed(2))
  }
}
function toggleSummary() {
  isSummaryOpen.value = !isSummaryOpen.value
  // jQuery('.heading-price').slideToggle(.1);
}
</script>
<style lang="scss" scoped>
.order-summary-block {
  padding: 24px 0;
  border-bottom: 1px solid #dee2e6;
  border-top: 1px solid #dee2e6;
  margin-bottom: 16px;
}

.summary-block-heading {
  cursor: pointer;
}

.summary-wrapper {
  padding-top: 24px;

  div:not(:last-child) {
    padding-bottom: 12px;
  }
}

.rotate-180 {
  transform: rotate(180deg);
  transition: 0.4s ease;
}

.chevron-icon {
  transition: 0.4s ease;
  width: 14px;
  height: 14px;
  margin-left: 16px;
  display: flex;
}

.heading-price {
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
}

.step-title-v2 {
  margin-bottom: 20px;
}

.step-title-v2 .title {
  font-size: 16px;
  margin-bottom: 5px;
  font-weight: 500;
  font-family: Roboto, sans-serif;
}

.fade-in-out-enter-active,
.fade-in-out-leave-active {
  transition: opacity 0.5s ease;
}

.fade-in-out-enter-from,
.fade-in-out-leave-to {
  opacity: 0;
}
</style>
